export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="inline-flex items-center gap-2 cursor-pointer">
                <span className="text-xl font-heading font-black text-primary-400 tracking-tight">
                  91黑料
                </span>
              </a>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
                91黑料网汇集全网最新吃瓜视频与爆料资讯，提供不打烊的网站入口与APP下载，是广大吃瓜群众获取第一手黑料内容的首选平台。全天候追踪娱乐圈、网红圈与社交平台热点事件。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热搜榜单</a>
                <a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
                <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新快讯</a>
                <a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门内容</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">服务入口</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#app" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">APP下载</a>
                <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">投稿爆料</a>
                <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问答</a>
                <a href="#about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-4 flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 91黑料网. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>24h不打烊</span>
              <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
              <span>吃瓜第一站</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}